import { ArrowRightIcon, DocumentTextIcon, DollarCircleIcon, LocationIcon } from 'icons';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';
import { UniversityTypes, useAllUniversities } from 'modules/universities';

const Universities = () => {
  const t = useTranslations();
  const { universities } = useAllUniversities({
    type: UniversityTypes.PRIVATE,
    size: 6
  });

  return (
    <div className="my-20 mx-auto max-w-[1150px] px-4">
      <div className="flex flex-col items-center justify-center">
        <p className="font-medium text-emerald-600">{t('home.oliygohlar.green_title')}</p>
        <h2 className="mb-10 text-xl font-semibold sm:text-2xl lg:text-3xl">
          {t('home.oliygohlar.main_title')}
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {universities?.data?.map((university, index) => (
          <Link
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            href={`${globalConst.pageNames.PRIVATE_UNIVERSITIES}/${university?.slug}`}
            className="min-h-40 block h-full rounded-xl bg-white transition-transform duration-200 hover:scale-105"
          >
            <div className="flex h-full flex-col justify-between p-3">
              <div>
                <div className="flex items-center gap-2">
                  <div className="relative flex max-h-9 min-h-9 min-w-9 max-w-9 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-gray-50">
                    <Image
                      src={university?.logo || '/images/default-no-logo.webp'}
                      alt={university?.name?.slice(0, 1)}
                      width={university?.logo ? 40 : 18}
                      height={university?.logo ? 40 : 18}
                      className="object-contain"
                      title="Universitet logosi"
                    />
                  </div>
                  <div className="text-base font-medium">
                    <h4 className="line-clamp-1 text-sm">{university?.name}</h4>
                    <div className="item-center flex gap-1 text-xs text-indigo-600">
                      <div className="flex-shrink">
                        <LocationIcon size="14" />
                      </div>
                      <p className="line-clamp-1">{university?.address}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-4 line-clamp-2 text-xs text-gray-600">
                  {university?.description ?? t('tavsif_mavjud_emas')}
                </div>
              </div>

              {/* Bottom block always at the bottom */}
              <div className="flex gap-2">
                <div className="flex items-center gap-2 rounded-xl bg-gray-50 px-2 py-1.5 flex-1">
                  <div className="text-blue-500">
                    <DollarCircleIcon />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[0.5rem] text-gray-400">{t('kontrakt_tolovi')}</span>
                    <span className="text-[0.625rem] font-medium text-gray-900">
                      {Number(university?.min_contract_price).toLocaleString('ru')} -{' '}
                      {Number(university?.max_contract_price).toLocaleString('ru')} UZS
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 rounded-xl bg-green-50 px-2 py-1.5">
                  <div className="text-green-500">
                    <DocumentTextIcon />
                  </div>
                  <div className="flex flex-col">
                    <span className="text-[0.5rem] text-gray-400">{t('Yonalishlar')}</span>
                    <span className="text-[0.625rem] font-medium text-gray-900">{university?.direction_count}</span>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
      <div className="mt-8 flex items-center justify-center">
        <Link
          href={globalConst.pageNames.PRIVATE_UNIVERSITIES}
          className="flex items-center gap-1 rounded-lg font-medium border-none bg-green-500 px-5 py-2 text-sm text-white transition-transform duration-200 hover:scale-105"
        >
          {t('home.oliygohlar.button_title')}
          <ArrowRightIcon />
        </Link>
      </div>
    </div>
  );
};

export default Universities;
